import { URL_UPDATE_MENU_SUBTAB } from 'constants/urls';

/**
 * @function updateSubTabApi
 * @param { Object[] } subtabs
 * @param { string } subtabs.groupId
 * @param { string } subtabs.id
 * @param { string } subtabs.name
 * @param { string } subtabs.url
 * @param { string } subtabs.desc
 * @param { string } subtabs.order
 * @param { string } subtabs.subtabId
 * @param { boolean } subtabs.checked
 * @returns { void }
 */
async function updateSubTabApi(subtabs) {
	const options = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json;charset=UTF-8' },
		body: JSON.stringify(subtabs),
	};

	const res = await fetch(URL_UPDATE_MENU_SUBTAB, options);

	if (!res.ok) {
		const message = `HTTP error! status: ${res.status}`;
		throw new Error(message);
	} else {
		const { msg } = await res.json();
		return msg;
	}
}

export default updateSubTabApi;
